import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  validationRequired: {
    description: 'Nickname validation requirement error',
    defaultMessage: 'Nickname is Required',
    id: 'WdunBB',
  },
});
